import { approve } from "@/service/unit";
import UploadFile from "../modal/Upload/upload-file.vue";
export default {
  name: "certification",
  components: {
    UploadFile
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    unit: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      modal: {
        visible: false,
        loading: false
      },
      select: false,
      formObj: {
        blrn: "",
        blrnPicture: "",
        unitPicture: "",
        corpn: "",
        corpnTel: "",
        originCode: ""
      },
      ruleCustom: {
        originCode: [{
          message: $t("jgbkoj9", "请输入使用过的代码")
        }, {
          pattern: /^[a-zA-Z0-9\\-]{1,50}$/,
          message: $t("5ecvi4k", "公司代码由1-50位的纯数字字母和-组成"),
          trigger: "blur"
        }],
        blrn: [{
          required: true,
          message: $t("f9o1nr8", "请输入营业执照号")
        }, {
          pattern: /^[a-zA-Z0-9]{0,25}$/,
          message: $t("vg67y7i", "只能输入25个以内字符的数字或者字母"),
          trigger: "blur"
        }],
        blrnPicture: [{
          required: true,
          message: $t("yhnos59", "请上传营业执照图片"),
          trigger: "blur,change"
        }],
        unitPicture: [{
          required: true,
          message: $t("b3whrv7", "请上传门店图片"),
          trigger: "blur,change"
        }],
        corpn: [{
          required: true,
          message: $t("jgz03z7", "请输入法人名称"),
          trigger: "blur"
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,25}$/,
          message: $t("1af50jj", "仅支持2-25个字符的字母,数字和汉字"),
          trigger: "blur"
        }],
        corpnTel: [{
          required: true,
          message: $t("zb8a1y8", "请输入法人手机号")
        }, {
          /*eslint-disable*/
          pattern: /^[0-9\-]{1,32}$/,
          message: $t("mrr1pti", "联系电话由1-32位的纯数字和-组成")
        }]
      },
      upload: {
        action: "/api/file/upload",
        callback() {
          return (res, file) => {
            file.url = res.retVal;
          };
        }
      },
      defaultFileListMap: {
        blrnPicture: [],
        unitPicture: []
      }
    };
  },
  watch: {
    visible(val) {
      val && this.init();
      this.modal.visible = val;
    }
  },
  methods: {
    /* 提交事件 */
    onCommit() {
      /* 验证 */
      this.$refs["formCustom"].validate(async valid => {
        if (valid) {
          this.modal.loading = true;
          const params = {
            ...this.formObj
          };
          params.unitId = this.unit.unitId;
          let {
            data: {
              result
            }
          } = await approve(params);
          if (result === 0) {
            this.$emit("update");
            this.clean();
          }
          this.modal.loading = false;
        }
      });
    },
    /* 不显示弹窗 */
    clean() {
      this.$refs["formCustom"].resetFields();
      this.$refs["blrnPicture"].clearFiles();
      this.$refs["unitPicture"].clearFiles();
      this.$emit("close");
    },
    init() {
      this.setInit();
    },
    setInit() {
      this.formObj.originCode = this.unit.originCode;
      this.formObj.blrn = this.unit.blrn;
      this.formObj.corpn = this.unit.corpn;
      this.formObj.corpnTel = this.unit.corpnTel;
      this.formObj.blrnPicture = this.unit.blrnPicture;
      this.formObj.unitPicture = this.unit.unitPicture;
      // 图片回显
      this.defaultFileListMap.blrnPicture = this.formObj.blrnPicture ? [{
        url: this.formObj.blrnPicture
      }] : [];
      this.defaultFileListMap.unitPicture = this.formObj.unitPicture ? [{
        url: this.formObj.unitPicture
      }] : [];
    },
    mouseEnter() {
      this.select = true;
    },
    mouseLeave() {
      this.select = false;
    },
    onChangeFileList(code, fileList) {
      console.log(fileList);
      this.formObj[code] = fileList[0] ? fileList[0].url : "";
    },
    onChangeFileList2(code, fileList) {
      this.formObj[code] = fileList[0] ? fileList[0].url : "";
    },
    onChangeOriginCode() {
      this.formObj.originCode = this.formObj.originCode.toUpperCase();
    }
  }
};